@if (isDrawer()) {
  @if (showToggle()) {
    <esn-icon-button
      class="esn-sidebar__toggle"
      icon="list-view"
      fill="transparent"
      [size]="44"
      [label]="toggleLabel()"
      [expanded]="open()"
      (clicked)="open.set(true)"
    />
  }
  <div class="esn-sidebar__scrim" [class.esn-sidebar__scrim--visible]="open()" aria-hidden="true" (click)="close()"></div>
}

<aside
  #panel
  class="esn-sidebar"
  [class.esn-sidebar--drawer]="isDrawer()"
  [class.esn-sidebar--open]="drawerOpen()"
  [id]="panelId"
  [attr.role]="isDrawer() ? 'dialog' : null"
  [attr.aria-modal]="drawerOpen() ? 'true' : null"
  [attr.aria-label]="isDrawer() ? label() : null"
  [attr.inert]="isDrawer() && !open() ? '' : null"
  (keydown)="handleKeydown($event)"
  (click)="handlePanelClick($event)"
>
  <div class="esn-sidebar__top">
    <esn-logo />

    @if (userName(); as name) {
      <div class="esn-sidebar__account">
        <ng-template #accountContent>
          <esn-avatar class="esn-sidebar__avatar" [name]="name" [imageUrl]="userImageUrl()" />
          <span class="esn-sidebar__name">{{ name }}</span>
        </ng-template>
        @if (accountInteractive()) {
          <button type="button" class="esn-sidebar__account-row esn-sidebar__account-row--button" (click)="accountClicked.emit($event)">
            <ng-container [ngTemplateOutlet]="accountContent" />
          </button>
        } @else {
          <div class="esn-sidebar__account-row"><ng-container [ngTemplateOutlet]="accountContent" /></div>
        }
      </div>
    }

    <nav class="esn-sidebar__nav" [attr.aria-label]="label()">
      <ng-content />
    </nav>
  </div>

  <div class="esn-sidebar__footer">
    <ng-content select="[esn-sidebar-footer]" />
    @if (themeSwitchLabel(); as switchLabel) {
      <div class="esn-sidebar__theme">
        <esn-switch [label]="switchLabel" [(checked)]="lightTheme" />
      </div>
    }
  </div>
</aside>
